import { all } from "redux-saga/effects";

import { loadIntegrationLocationsWatcher } from "./load";
import { requestAddIntegrationLocationWatcher } from "./add";

export default function* locationSagas() {
    yield all([loadIntegrationLocationsWatcher(), requestAddIntegrationLocationWatcher()]);
}